import { create } from 'zustand';
import { persist } from "zustand/middleware";

export interface Features {
  dashboardV2: boolean;
  clientType: string;
}

interface FeatureStore {
  featureFlags: Features | null;
  setFeatureFlags: (newFeaturesObj: Features) => void;
  clearFeatureFlags: () => void;
}

export const useFeatureStore = create<FeatureStore>((set) => ({
  featureFlags: { dashboardV2: true, clientType: 'PRO' },
  setFeatureFlags: (newFeaturesObj) => set({ featureFlags: newFeaturesObj }),
  clearFeatureFlags: () => set({ featureFlags: { dashboardV2: true, clientType: 'PRO' } }),
}));

interface PortalStore {
  redirectedToLegacy: boolean;
  setRedirectedToLegacy: (newFlag: boolean) => void;
  clearPortalStore: () => void;
}

export const usePortalStore = create<PortalStore>()(
  persist(
    (set) => ({
      redirectedToLegacy: false,
      setRedirectedToLegacy: (newFlag) => set({ redirectedToLegacy: newFlag }),
      clearPortalStore: () => {
        set({ redirectedToLegacy: false });
        localStorage.removeItem('PortalStore');
      },
    }),
    { name: 'PortalStore' }
  )
);

export default useFeatureStore;
